// extracted by mini-css-extract-plugin
export default {"relatoriosContainer":"RelatoriosPagamentos_relatoriosContainer__GNane","reportSection":"RelatoriosPagamentos_reportSection__2bOXg","backBtn":"RelatoriosPagamentos_backBtn__wgnH6"};